<template lang="pug">
#sub-empresa-bloco-dados-contrato-originacao
    h2.mb-3.mt-3 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.titulo') }}
    el-card(shadow='never', :body-style='{ padding: "16px" }')
        .bloco-dados-contrato-originacao__linha
            .bloco-dados-contrato-originacao-informacao
                .bloco-dados-contrato-originacao-codigo-externo
                    h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.codigoExterno') }}
                    el-tooltip(v-if='dados.codigoExterno', placement='top')
                        .codigo-externo--tooltip(slot='content') {{ tooltipCopiarCodigo }}
                        i.mdi.mdi-content-copy(
                            @click='copiarCodigoParaAreaTransferencia(dados.codigoExterno)'
                        )
                    i.el-icon-edit(@click='atualizarModalCodigoExterno(true)')
                p.codigo-externo--minificado {{ dados.codigoExterno ? dados.codigoExterno : '--' }}
            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.numeroContrato') }}
                p {{ dados.numeroContrato }}

            .bloco-dados-contrato-originacao-informacao(v-if='isUsuarioLDC && dados.subTradingNome')
                h4 Trading
                p {{ dados.subTradingNome }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.cultura') }}
                p {{ dados.materialNome }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.safra') }}
                p {{ dados.safraNome }}

        .bloco-dados-contrato-originacao__linha

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.volumeContratado') }}
                p {{ dados.volumeContratado }}
                
            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.dataContrato') }}
                p {{  dados.dataContrato }}

            .bloco-dados-contrato-originacao-informacao(
                v-if='!this.ambienteLogadoPY'
            )
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.municipios`) }}
                p {{ dados.municipioNome }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.${this.ambienteLogadoPY ? 'departamento' : 'estado'}`) }}
                p {{ this.ambienteLogadoPY ? dados.localidadeNivelUmNome : dados.estadoSigla }}

    div(v-if='modalCodigoExternoVisivel')
        BlocoInserirCodigoExterno(
            :dados='dados',
            :dialogVisible='modalCodigoExternoVisivel',
            @fechar='atualizarModalCodigoExterno'
        )
</template>

<script>
import BlocoInserirCodigoExterno from '@/components/contratosOriginacao/SubEmpresaBlocoInserirCodigoExterno.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'SubEmpresaBlocoDadosVisualizarContratoOriginacao',
    components: {
        BlocoInserirCodigoExterno
    },

    props: {
        dados: {
            required: true,
            type: Object
        }
    },

    computed: {
        ...mapGetters(['usuarioLogado']),

        ambienteLogadoPY() {
            return this.usuarioLogado.ambienteLogado === 'PY';
        },
        isUsuarioLDC() {
            return this.usuarioLogado?.isLDCRevenda === true;
        }
    },

    data() {
        return {
            modalCodigoExternoVisivel: false,
            tooltipCopiarCodigo: 'Copie o código'
        };
    },

    methods: {
        copiarCodigoParaAreaTransferencia() {
            this.tooltipCopiarCodigo = 'Copiado';
            navigator.clipboard
                .writeText(this.dados.codigoExterno)
                .then(() => {
                    setTimeout(() => {
                        this.tooltipCopiarCodigo = 'Copie o código';
                    }, 1000);
                })
                .catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.error('Erro ao copiar o texto: ', error);
                });
        },

        atualizarModalCodigoExterno(value) {
            this.modalCodigoExternoVisivel = value;
        }
    }
};
</script>

<style lang="scss" scoped>
#sub-empresa-bloco-dados-contrato-originacao {
    .mb-3 {
        font-weight: bold;
        margin-bottom: 20px;
    }
    .bloco-dados-contrato-originacao__linha {
        display: grid;
        grid-template-columns: repeat(5, 1fr);

        h4 {
            font-weight: bold;
            color: var(--primary);
        }
    }

    .bloco-dados-contrato-originacao-codigo-externo {
        display: flex;
        align-items: center;
        gap: 5px;

        i {
            cursor: pointer;
        }

        i:hover {
            color: var(--primary);
            font-weight: bold;
        }
    }

    .bloco-dados-contrato-originacao-informacao {
        min-width: 155px;

        .codigo-externo--minificado {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        p {
            word-break: break-all;
            max-width: 155px;
        }
    }
    .el-card.codigo-externo.is-never-shadow {
        margin-top: 4px;
    }
}
.codigo-externo--tooltip {
    width: 90px;
    text-align: center;
}
</style>
